import { Component } from '@angular/core';

@Component({
  selector: 'app-cpe-factura',
  templateUrl: './cpe-factura.component.html',
  styleUrls: ['./cpe-factura.component.scss']
})
export class CpeFacturaComponent{


}
